/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa SubscribeUnsubscribe
 *
 */

Intesa.SubscribeUnsubscribe = function () {

var subscribeUnsubscribe = this;

var isCaptcha = false;

var form = $("#unsubscribeForm").length!=0 ? $("#unsubscribeForm"): $("#subscribeForm") ;

var formNoMessageId = $("section.errorNoMessageId");

this.init = function (){
    console.log("SubscribeUnsubscribe");
    console.log(form);
	console.log($(form).attr("id"));
    if( form.length > 0){
    	var hasMessageId = subscribeUnsubscribe.checkMessageId();
    	if(hasMessageId){
			if($("input[name='recaptchaKey']").length >= 1){
				window.grecaptcha.execute($("body").find(".g-recaptcha").attr("sitekey"), {
					action: "contact"
				}).then(function (token) {
					$(".g-recaptcha-response").val(token);
					window.recaptchaCallback.call()
				});
			}
    		//Logica esiste messageId in url
        	subscribeUnsubscribe.enableSumbitDynamicForm();
    	}else{
    		//Logica non esiste messageId in url
    	}
		subscribeUnsubscribe.redirectAfterSuccess();
    }
};


this.recaptchaCallback = function () {
	console.log("Captcha Verified");
	isCaptcha = true;
	window.checkUnsubscribeForm(isCaptcha);
	window.checkSubscribeForm(isCaptcha);
}

this.validationCallback = function () {
	console.log("Captcha Verified");
	isCaptcha = true;
	window.checkUnsubscribeForm(isCaptcha);
	window.checkSubscribeForm(isCaptcha);
}

window.recaptchaCallback = $("input[name='recaptchaKey']").length >= 1 ? this.validationCallback : this.recaptchaCallback;


this.checkMessageId = function () {
	console.log("checkMessageId()");
	var url = new URL(location.href);
	var messageId = url.searchParams.get("messageId");
	if(messageId != undefined && messageId.length > 0 ) {
		//Imposto il messageId nel form
		 form.find("[name='messageId']").val(messageId);
	}else{
		 return false;
	}
	return true;
}

this.enableSumbitDynamicForm = function () {
	console.log("enableSumbitDynamicForm()");
	console.log(isCaptcha);
	if( $(form).attr("id") == "unsubscribeForm" ){
		$(form).find("input").on("change", function (element) {
			if(element.parsley().validate() && isCaptcha){
				var submit =  form.find(".submit__unsubscribe").attr("disabled");
				if (typeof submit !== 'undefined' && submit !== false) {
					 form.find(".submit__unsubscribe").removeAttr("disabled");
				}
			}else{
				var submit =  form.find(".submit__unsubscribe").attr("disabled");
				if (typeof submit == 'undefined' && submit === false) {
					 form.find(".submit__unsubscribe").attr("disabled");
				}
			}
		});
	} else {
		$(form).find("input").on("change", function (element) {
			if(element.parsley().validate() && isCaptcha){
				var submit =  form.find(".submit__subscribe").attr("disabled");
				if (typeof submit !== 'undefined' && submit !== false) {
					 form.find(".submit__subscribe").removeAttr("disabled");
				}
			}else{
				var submit =  form.find(".submit__subscribe").attr("disabled");
				if (typeof submit == 'undefined' && submit === false) {
					 form.find(".submit__subscribe").attr("disabled");
				}
			}
		});
	}


this.redirectAfterSuccess = function (){
	
	if( $(form).attr("id") == "unsubscribeForm" ){

		if($("#unsubscribeSuccess").length > 0 ){
			$("#recapModalUnsubscribe").on("hidden.bs.modal", function () {
				var link = $("#redirectUnsubscribe").length > 0 ? $("#redirectUnsubscribe").val() : "" ;
				console.log("modal dismiss event");
				if(link != "" ){
					console.log("redirecting");
					window.location.href = link;
				}else{
					console.log("missing redirect");
				}
				
			});
		}
	} else {
		if($("#subscribeSuccess").length > 0 ){
			$("#recapModalSubscribe").on("hidden.bs.modal", function () {
				var link = $("#redirectSubscribe").length > 0 ? $("#redirectSubscribe").val() : "" ;
				console.log("modal dismiss event");
				if(link != "" ){
					console.log("redirecting");
					window.location.href = link;
				}else{
					console.log("missing redirect");
				}
				
			});
		}
	}

}
    
}

window.checkUnsubscribeForm = function (isCaptchaParam){
	
	var unsubscribeForm = $("#unsubscribeForm");
	
	console.log("checkUnsubscribeForm()");
	
	if(unsubscribeForm.length > 0){
		
		console.log("inside checkUnsubscribeForm");
		
		var isValid =  unsubscribeForm.parsley().validate();
		
		if(isValid && isCaptchaParam){
			var submit =  unsubscribeForm.find(".submit__unsubscribe").attr("disabled");
			console.log("submit ->",submit);
			if (typeof submit !== 'undefined' && submit !== false) {
				unsubscribeForm.find(".submit__unsubscribe").removeAttr("disabled");
			}
		}else{
			console.log("submit ->",submit);
			var submit =  unsubscribeForm.find(".submit__unsubscribe").attr("disabled");
			if (typeof submit == 'undefined' && submit === false) {
				unsubscribeForm.find(".submit__unsubscribe").attr("disabled");
			}
		}
	}
}

window.checkSubscribeForm = function (isCaptchaParam){
	
	var subscribeForm = $("#subscribeForm");
	
	console.log("checkSubscribeForm()");
	
	if(subscribeForm.length > 0){
		
		console.log("inside checkSubscribeForm");
		
		var isValid =  subscribeForm.parsley().validate();
		
		if(isValid && isCaptchaParam){
			var submit =  subscribeForm.find(".submit__subscribe").attr("disabled");
			console.log("submit ->",submit);
			if (typeof submit !== 'undefined' && submit !== false) {
				subscribeForm.find(".submit__subscribe").removeAttr("disabled");
			}
		}else{
			console.log("submit ->",submit);
			var submit =  subscribeForm.find(".submit__subscribe").attr("disabled");
			if (typeof submit == 'undefined' && submit === false) {
				subscribeForm.find(".submit__subscribe").attr("disabled");
			}
		}
	}
}

}
 
 /**
  * Get class instance
  *
  */
Intesa.SubscribeUnsubscribe.getInstance = function () {

    if (!window.intesa) {

        window.intesa = new Object();

    }
    if (!window.intesa.SubscribeUnsubscribe) {

        window.intesa.SubscribeUnsubscribe = new Intesa.SubscribeUnsubscribe();

    }

    return window.intesa.SubscribeUnsubscribe;

};
 